const btn_menu = document.querySelector('#btn-menu')
const menu = document.querySelector('#menu')

btn_menu.addEventListener('click', toggleMenu)

function toggleMenu() {
  menu.setAttribute(
    'aria-expanded',
    menu.getAttribute('aria-expanded') === 'false' ? 'true' : 'false'
  )
}

// close menu when a link is clicked
const links = document.querySelectorAll('#menu a')
links.forEach((link) => {
  link.addEventListener('click', toggleMenu)
})
